import { useEffect, useRef, useState } from 'react'
import { CalendarOutlined } from '@ant-design/icons'
import { formatHeaderDate } from '@/features/calendar/utils'
import styles from './HeaderDate.module.css'

interface Props {
  onClick: () => void
}

export function HeaderDate({ onClick }: Props) {
  const [label, setLabel] = useState(() => formatHeaderDate(new Date()))
  const offsetRef = useRef(0)

  useEffect(() => {
    let cancelled = false

    const sync = async () => {
      try {
        const res = await fetch('/api/time', { credentials: 'include' })
        if (!res.ok) throw new Error(res.statusText)
        const data = (await res.json()) as { ms?: number }
        if (!cancelled) offsetRef.current = (data.ms || 0) - Date.now()
      } catch {
        if (!cancelled) offsetRef.current = 0
      }
    }

    const tick = () => {
      setLabel(formatHeaderDate(new Date(Date.now() + offsetRef.current)))
    }

    void sync().then(tick)
    const timer = setInterval(tick, 60_000)
    const syncTimer = setInterval(() => void sync(), 5 * 60_000)
    return () => {
      cancelled = true
      clearInterval(timer)
      clearInterval(syncTimer)
    }
  }, [])

  return (
    <button
      type="button"
      className={styles.pill}
      onClick={onClick}
      aria-label="Производственный календарь"
      title="Производственный календарь (РФ)"
    >
      <CalendarOutlined className={styles.icon} />
      <span className={styles.label}>{label}</span>
    </button>
  )
}
